import { Card, CardHeader, Text, makeStyles, shorthands, tokens, Caption1, CardFooter, Button } from "@fluentui/react-components";
import { InfoRegular, ErrorCircleRegular, DocumentRegular, FolderRegular, DocumentMultipleRegular, LinkRegular } from "@fluentui/react-icons";
import { IItemLinksResultCardProps } from "./item-links-result-card.props";
import { ILocaleStrings } from "loc/locale.interfaces";
import { useL10n } from "context/l10n-context";
import { getSharingLinkPermissionDisplayText } from "lib/sharing-link-permissions";

const layoutStyles = makeStyles({
    divider: {
        ...shorthands.borderBottom('1px', 'solid', tokens.colorNeutralStrokeSubtle),
        ...shorthands.margin(0, 0, '1em', 0)
    },
    itemWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ...shorthands.margin('1em', 0, 0, 0)
    },
    itemImageWrapper: {
        marginRight: tokens.spacingHorizontalM
    },
    textWrapper: {
        ...shorthands.overflow('hidden'),
        '> span': {
            display: 'block',
            ...shorthands.overflow('hidden'),
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }
});

export default function ItemLinksResultCard(props: IItemLinksResultCardProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();
    
    const { removedLinks } = props;

    if (removedLinks.length === 0) {
        return null;
    }

    // All links should be from the same item
    const firstLink = removedLinks[0];
    
    // Header: "Project Mayflour document.docx" 
    const headerTitle = firstLink.itemName;
    
    // Description: "https://site/folder/item.url"
    const headerDescription = firstLink.itemUrl;

    // Get item type icon
    const getItemIcon = (itemType: number): JSX.Element => {
        switch (itemType) {
            case 1: // File
                return <DocumentRegular fontSize={28} />;
            case 2: // Folder
                return <FolderRegular fontSize={28} />;
            default:
                return <DocumentMultipleRegular fontSize={28} />;
        }
    };

    // Body message: "Removed X sharing links."
    const removedCount = removedLinks.length;
    const bodyMessage = t('ppaRemoveSharingLinksActionRemovedLinksFromItem', { count: removedCount });

    return (
        <Card>
            <CardHeader
                image={getItemIcon(firstLink.itemType)}
                header={<div className={styles.textWrapper}><Text as="span">{headerTitle}</Text></div>}
                description={<div className={styles.textWrapper}><Caption1 as="span">{headerDescription}</Caption1></div>}
            />
            <div>
                <div className={styles.divider}></div>
                <Caption1 as="span">{bodyMessage}</Caption1>
                {removedLinks.map((link, idx) => (
                    <div key={idx} className={styles.itemWrapper}>
                        <div className={styles.itemImageWrapper}>
                            <LinkRegular fontSize={28} />
                        </div>
                        <div>
                            <div className={styles.textWrapper}>
                                <Text as="span">
                                    {getSharingLinkPermissionDisplayText(link.permissionType, t)} - {link.shareId}
                                </Text>
                            </div>
                            <div className={styles.textWrapper}><Caption1 as="span">{link.itemName}</Caption1></div>
                        </div>
                    </div>
                ))}
            </div>
            <CardFooter>
                {props.messages.length > 0 &&
                    <Button onClick={props.onMessagesClick} icon={<InfoRegular fontSize={16} />}></Button>}
                {props.errorCount > 0 &&
                    <Button onClick={props.onErrorsClick} icon={<ErrorCircleRegular fontSize={16} />}>{props.errorCount} Errors</Button>}
            </CardFooter>
        </Card>
    );
}